<template>
  <aside class="aside-top">
    <div class="title">欧瑞科斯出入库管理系统</div>
    <div class="message">
      <el-dropdown trigger="click" placement="top" class="header" @command="dropdownHandle">
        <span class="el-dropdown-link header">
          <span class="head-portrait default header-bt" v-if="!userMessage.logo" >{{userMessage.user_name.slice(0,1) || ""}}</span>
			    <img :src="userMessage.logo" v-else>
          <span class="name">{{ userMessage.user_name || "--" }}</span>
          <i class="el-icon-arrow-down el-icon--right" v-if="type != 'resetPassword'"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="personalCenter" v-if="type != 'resetPassword'">个人中心</el-dropdown-item>
          <el-dropdown-item command="changePassword" v-if="type != 'resetPassword'">修改密码</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span class="line"></span>
      <span class="sign-out" @click="loginOut">退出</span>
    </div>
    <page-pop v-if="isShowChangePassword" :title="'修改密码'" @close="popCloseHandle" class="change-password-box">
      <el-form ref="form" :model="passwordForm" class="form">
        <el-form-item label="旧密码" label-width="100px">
          <el-input v-model="passwordForm.oldpassword" placeholder="旧密码" show-password clearable></el-input>
        </el-form-item>
        <el-form-item label="新密码" label-width="100px">
          <el-input v-model="passwordForm.newpassword" placeholder="新密码" maxlength="18" show-password clearable></el-input>
        </el-form-item>
        <p class="tip">密码至少包含 数字和英文，长度6-20</p>
        <el-form-item label="确认新密码" label-width="100px">
          <el-input v-model="passwordForm.newpassword2" placeholder="确认新密码" maxlength="18" show-password clearable></el-input>
        </el-form-item>
      </el-form>
      <div class="bottom" ref="bottom">
        <span class="bt cancel-bt-sytle" @click="popCloseHandle">取消</span>
        <span class="bt" @click="changePasswordHandle">保存</span>
      </div>
    </page-pop>
  </aside>
</template>

<script>
import { Logout, ChangePassWrod } from "@/service/api.js";
import { mapGetters } from 'vuex';
import { gotoRoute } from "@/utils/utilsRouter.js"
export default {
  data() {
    return {
      isShowChangePassword: false,
      passwordForm: {
        oldpassword: "",
        newpassword: "",
        newpassword2: "",
        userMessage: {},
      },
    };
  },
  props: ['type'],
  computed: {
    ...mapGetters(['getUserMessage', 'getEditableTabs']),
  },
	created(){
    if(this.type == "resetPassword") {
      this.userMessage = this.$route.query;
    } else {
      this.userMessage = this.getUserMessage;
    }
	},
  methods: {
    loginOut() {
			this.$confirm("确定退出吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(async () => {
				let data = await Logout();
				if (data) {
					this.$store.commit("LOGIN_OUT");
          this.$store.commit('setCompanyList', "");
          this.$store.commit('setCompanyObj', "");
          if(this.type !== "resetPassword"){
            /* 防止切换角色时addRoutes重复添加路由导致出现警告 */
					  window.location.reload();
          } else {
            this.$router.push('/login')
          }
				}
      });
    },
    dropdownHandle(val){
      if(this.type == "resetPassword") return;
      if(val == "changePassword"){
        this.isShowChangePassword = true;
      } else if(val == "personalCenter"){
        gotoRoute({
          name: 'userCenter',
          meta:{
            name: '个人中心'
          }
        })
      }
    },
    // gotoRoute(value) {
    //   let name = value.name;
    //   this.$router.push({ name });
    //   this.$store.commit('setEditableTabsValue',value.name)
    //   let isHas = false;
    //   this.getEditableTabs.forEach((item)=>{
    //     if(item.name == name){
    //       isHas = true;
    //     }
    //   })
    //   if(!isHas){
    //     this.$store.commit('addEditableTabs', {
    //       title: value.meta.name,
    //       name: value.name,
    //       closable: true
    //     }) 
    //   }
    // },
    popCloseHandle(){
      this.isShowChangePassword = false;
    },
    async changePasswordQuery(){
      let param = {
        oldpassword: this.$md5(this.passwordForm.oldpassword),
        newpassword: this.$md5(this.passwordForm.newpassword),
        newpassword2: this.$md5(this.passwordForm.newpassword2),
      }
      let data = await ChangePassWrod(param);
      if (data) {
        this.$message({
          message: '密码修改成功,请重新登录！',
          type: 'success'
        });
        this.popCloseHandle();
        setTimeout(()=>{
          this.$store.commit("LOGIN_OUT");
          /* 防止切换角色时addRoutes重复添加路由导致出现警告 */
          window.location.reload();
        }, 1000)
      }
    },
    changePasswordHandle(){
      this.passwordForm.oldpassword = this.passwordForm.oldpassword.trim();
      this.passwordForm.newpassword = this.passwordForm.newpassword.trim();
      this.passwordForm.newpassword2 = this.passwordForm.newpassword2.trim();
      if(!this.passwordForm.oldpassword || !this.passwordForm.newpassword || !this.passwordForm.newpassword2){
        this.$message({
          message: '请填写完整',
          type: 'warning'
        });
        return;
      }
      if(this.passwordForm.newpassword !== this.passwordForm.newpassword2){
        this.$message({
          message: '确认密码与新密码填写不一致',
          type: 'warning'
        });
        return;
      }
      if(this.passwordForm.newpassword === this.passwordForm.oldpassword){
        this.$message({
          message: '旧密码与新密码相同',
          type: 'warning'
        });
        return;
      }
      // 密码至少包含 数字和英文，长度6-18
      let passwordReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/;
      if(!passwordReg.test(this.passwordForm.newpassword)){
        this.$message({
          message: '密码至少包含数字和英文，长度6-18',
          type: 'warning'
        });
        return;
      }
      this.changePasswordQuery();
    }
  },
  components: {  },
};
</script>

<style lang="scss" scoped>
.aside-top {
  padding-right: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  background: #fff;
  color: #333;
  font-size: 14px;
  .title {
    margin-left: 15px;
    font-size: 18px;
  }
  .message {
    display: flex;
    align-items: center;
    .head-portrait {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .line {
      width: 1px;
      height: 15px;
      background: #e9e7e7;
      margin: 0 10px;
    }
    .sign-out {
      padding-left: 20px;
      background: url("../../../../public/images/index/sign-out.webp") left
        center no-repeat;
      background-size: 16px;
      cursor: pointer;
      &:hover {
        color: #1f2e54;
      }
    }
  } 
  .header { 
    .header-bt {
      width: 38px;
      height: 38px; 
      border-radius:50%;
      display: flex;
      align-items:center;
      justify-content: center;
      color:#fff;
      font-size: 19px;
    }
    .default {
      background:#f56c6c;
    } 
    img {
      width: 38px;
      height: 38px;
      border-radius:50%;
      margin-right: 10px;
    } 
  }
}
.change-password-box {
  .tip {
    font-size: 12px;
    color: #999;
    position: relative;
    left: 99px;
    top: -9px;
  }
  .bottom {
    display: flex;
    position: relative;
    top: -14px;
    right: 15px;
    // justify-content: center !important;
  }
}
</style>
